import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import { UseFormWatch } from "react-hook-form";

import PatientDetails from "./PatientDetails";
import { flexAlignCentre } from "../../styles/mui/styles/display";
import { priorAuthHeader, StickyContainer } from "../../app/styles/styles";
import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { MemberInfoData } from "../../models/Patient";

export interface PropsFromState {
  watch: UseFormWatch<any>;
  memberInfoDataState: MemberInfoData;
  label: string;
  type: number;
}
type AllProps = PropsFromState;

const PatientInfo: React.FC<any> = ({
  watch,
  memberInfoDataState,
  label,
  type
}: AllProps) => {
  return (
    <>
      <Grid container sx={priorAuthHeader}>
        <Grid size={4}>
          <Grid container sx={flexAlignCentre}>
            <Typography
              variant="subtitle1"
              textAlign="center"
              pl={"1.5rem"}
              fontWeight={fontWeight[6]}
              color={colors.black[2]}
            >
              {label}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={StickyContainer}>
        <PatientDetails
          watch={watch}
          memberInfoDataState={memberInfoDataState}
          type={type}
        />
      </Grid>
    </>
  );
};

export default PatientInfo;
